module.exports = __webpack_public_path__ + "img/writingSeminar_041022_F.71ee06d4.jpg";